import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const GetTeamsWithSignupFormsInputSchema = z.object({});

export const GetTeamsWithSignupFormsOutputSchema = z.object({
  teams: z.array(
    z.object({
      _id: zExt.objectId(),
      name: z.string(),
      totalCount: z.number(),
      migratedCount: z.number(),
      spotlightsEnabled: z.boolean(),
    }),
  ),
});

export type GetTeamsWithSignupFormsInput = z.infer<
  typeof GetTeamsWithSignupFormsInputSchema
>;
export type GetTeamsWithSignupFormsOutput = z.infer<
  typeof GetTeamsWithSignupFormsOutputSchema
>;

export const getTeamsWithSignupForms = {
  name: "getTeamsWithSignupForms" as const,
  input: GetTeamsWithSignupFormsInputSchema,
  output: GetTeamsWithSignupFormsOutputSchema,
};
